import React, {useEffect, useState} from 'react';
import './index.less';
import {Button, Drawer, Table, message, Spin, Pagination} from 'antd';
import {getScriptLibList, getScriptLibInfo, delScriptLibItem} from '../../../../services';
import * as dateFormat from '../../../../../../utils/dateFormat';
import {exportTxt} from '../../../../../../utils/exportTxt';

const supplement = {
    '1': {

    },
    '2': {

    }
};
const EditorAILibModal = (props) => {
    const {
        showScriptListModal,
        setShowScriptListModal,
        acScriptlibRef,
        currentScriptParams,
        aiScriptToolLog
    } = props;
    const [tableData, setTableData] = useState([]);
    const [total, setTotal] = useState(0);
    const [pageNum, setPageNum] = useState(1);
    const [num, setNum] = useState(10);
    const [isloading, setIsLoading] = useState(false);
    const downloadTxt = async (record) => {
        try {
            const {data, errno, errmsg} = await fetchTabItemInfo(record.id);
            aiScriptToolLog('library_download', {
                script_id: record.id
            });
            const text = data?.contents.reduce((value, item) => {
                return value  + item.content + '\n';
            }, '');

            const fileName = record.task_name;
            exportTxt(fileName, text);
        }
        catch (err) {
            console.log(err);
        }

    };
    const fetchTabItemInfo = async (id) => {
        const res = await getScriptLibInfo({id});
        return res;
    };
    const delItem = async (id) => {
        try {
            const {data, errno, errmsg} = await delScriptLibItem({id});
            if (errno === 0) {
                aiScriptToolLog('library_delete', {
                    script_id: id
                });
                message.success('删除成功');
                await getTabList();
                acScriptlibRef.current?.contentWindow.postMessage({
                    type: 'SCRIPT-LIB-DEL-ITEM',
                    data: {
                        originParams: currentScriptParams,
                        id
                    }
                });
            }
            else {
                message.error(errmsg);
            }
        }
        catch (err) {
            console.log(err);
        }

    };

    const editorItemInfo = async (item) => {
        try {
            const {errno, errmsg, data} = await fetchTabItemInfo(item.id);
            if (errno === 0) {
                acScriptlibRef.current?.contentWindow.postMessage({
                    type: 'SCRIPT-LIB-EDIT-INFO',
                    data: {
                        ...data
                    }
                });
                setShowScriptListModal(false);
                aiScriptToolLog('library_edit', {
                    script_id: data?.id
                });
            }
            else {
                message.error(errmsg);
            }
        }
        catch (e) {
            console.log(e);
        }
    };
    const editorColumns = [
        // {
        //     title: '脚本ID',
        //     dataIndex: 'id',
        //     key: 'id',
        //     width: '54px',
        //     render: (text) => <span>{text}</span>
        // },
        {
            title: '脚本名称',
            dataIndex: 'task_name',
            key: 'task_name',
            width: '200px',
            render: (text) => <div style={{maxWidth: 200, width: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{text}</div>
        },
        {
            title: '编辑者',
            dataIndex: 'user_name',
            key: 'user_name',
            width: '74px',
            render: (text) => <div style={{maxWidth: 200, width: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{text}</div>
        },
        {
            title: '更新时间',
            dataIndex: 'update_time',
            key: 'update_time',
            width: '200px',
            render: (text) => <span>{text}</span>
        },
        {
            title: '创建时间',
            dataIndex: 'create_time',
            key: 'create_time',
            width: '200px',
            render: (text) => <span>{text}</span>
        },
        {
            title: '操作',
            dataIndex: 'operate',
            fixed: 'right',
            key: 'operate',
            width: '168px',
            render: (value, record) => {
                return <div className="draw-operate">
                    <div
                        className="operate-btn"
                        onClick={() => {
                            editorItemInfo(record);
                        }}
                    >编辑</div>
                    <div
                        className="operate-btn"
                        onClick={() => {
                            downloadTxt(record);
                        }}
                    >下载</div>
                    <div
                        className="operate-btn"
                        onClick={() => {
                            delItem(record.id);
                        }}
                    >删除</div>
                </div>;
            }
        }
    ];
    const getTabList = async () => {
        setIsLoading(true);
        const {data, errno, errmsg} = await getScriptLibList({
            page_num: pageNum || 1,
            num: num || 5
        });
        if (errno === 0) {
            setTableData(data?.list || []);
            setTotal(data?.total || 0);
            setIsLoading(false);
        }
        else {
            message.error(errmsg);
            setIsLoading(false);
        }
    };

    const pageHandler = async (page, pageSize) => {
        setPageNum(page);
    };
    // useEffect(() => {
    //     if (showScriptListModal) {
    //         setPageNum(1);
    //         getTabList();
    //     }
    // }, [showScriptListModal]);
    useEffect(() => {
        getTabList();
    }, [pageNum]);
    return (
        <Drawer
            visible={showScriptListModal}
            width={1100}
            onClose={() => setShowScriptListModal(false)}
            closeIcon={false}
            className='editor-lib'
        >
            <div className='editor-lib-header'>
                <div className='editor-lib-header-title'>AI脚本库</div>
                <div
                    className='editor-lib-header-icon'
                    onClick={() => {
                        setShowScriptListModal(false);
                    }}
                >
                </div>
            </div>
            <div className='editor-lib-content'>
                <Spin spinning={isloading}>
                    <Table
                        columns={editorColumns}
                        dataSource={tableData}
                        rowKey='id'
                        pagination={false}
                    />
                </Spin>
            </div>
            <div className='editor-lib-content-pagination'>
                <Pagination
                    onChange={pageHandler}
                    showQuickJumper
                    showConfirm
                    total={total}
                    current={pageNum}
                    pageSize={num}
                    className="digital-faq-pagination"
                    locale={{
                        items_per_page: '条/页',
                        jump_to: '跳至',
                        jump_to_confirm: '确定',
                        page: '页',
                        prev_page: '上一页',
                        next_page: '下一页',
                        prev_5: '向前 5 页',
                        next_5: '向后 5 页',
                        prev_3: '向前 3 页',
                        next_3: '向后 3 页'
                    }}
                />
            </div>
        </Drawer>
    );
};
export default EditorAILibModal;